var map = {
	"./图片10.png": "bcf1",
	"./图片11.png": "0a47",
	"./图片12.png": "3957",
	"./图片13.png": "8c9b",
	"./图片14.png": "2c1e",
	"./图片15.png": "e75a",
	"./图片16.png": "45b2",
	"./图片2.png": "cb50",
	"./图片3.png": "9e8b",
	"./图片4.png": "2d04",
	"./图片5.png": "418e",
	"./图片6.png": "eed7",
	"./图片7.png": "2dfc",
	"./图片8.png": "79a2",
	"./图片9.png": "6f78"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c72c";